module.exports = __webpack_public_path__ + "static/media/S (53).7b31a14b.jpg";